import React, { FC } from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

interface OceanParticlesProps {
  id: string;
  size: number;
}

const OceanParticles: FC<OceanParticlesProps> = ({ size = 500, id }) => {
  const particleOptions: any = {
    autoPlay: true,
    // background: {
    //   color: {
    //     value: '#763c5c'
    //   }
    // },
    fullScreen: {
      enable: false,
      zIndex: 0
    },
    duration: 0,
    fpsLimit: 30,
    interactivity: {
      detectsOn: 'window',
      events: {},
      modes: {
        repulse: {
          distance: 100,
          duration: 1.4,
          factor: 100,
          speed: 1,
          maxSpeed: 50,
          easing: 'ease-out-quad',
          divs: {
            distance: 200,
            duration: 0.4,
            factor: 100,
            speed: 1,
            maxSpeed: 50,
            easing: 'ease-out-quad',
            selectors: []
          }
        }
      }
    },
    manualParticles: [],
    motion: {
      disable: false,
      reduce: {
        factor: 4,
        value: true
      }
    },
    particles: {
      bounce: {
        horizontal: {
          random: {
            enable: false,
            minimumValue: 0.1
          },
          value: 1
        },
        vertical: {
          random: {
            enable: false,
            minimumValue: 0.1
          },
          value: 1
        }
      },
      color: {
        value: '#a4cfd0'
      },
      gradient: [],
      groups: {},
      move: {
        angle: {
          offset: 0,
          value: 90
        },
        center: {
          x: 50,
          y: 50,
          radius: 0
        },
        decay: 0,
        distance: {},
        direction: 'none',
        drift: 0,
        enable: true,
        gravity: {
          acceleration: 9.81,
          enable: false,
          inverse: false,
          maxSpeed: 50
        },
        path: {
          clamp: true,
          delay: {
            random: {
              enable: false,
              minimumValue: 0
            },
            value: 0
          },
          enable: false,
          options: {}
        },
        outModes: {
          default: 'out',
          bottom: 'out',
          left: 'out',
          right: 'out',
          top: 'out'
        },
        random: true,
        size: false,
        speed: 0.6,
        spin: {
          acceleration: 0,
          enable: false
        },
        straight: false,
        trail: {
          enable: false,
          length: 10,
          fillColor: {
            value: '#000000'
          }
        },
        vibrate: false,
        warp: false
      },
      number: {
        density: {
          enable: true,
          area: 5000,
          factor: 1000
        },
        limit: 0,
        value: 160
      },
      opacity: {
        random: {
          enable: true,
          minimumValue: 0.1
        },
        value: {
          min: -1,
          max: 1
        },
        animation: {
          count: 0,
          enable: true,
          speed: 0.5,
          decay: 0,
          sync: false,
          destroy: 'none',
          startValue: 'random',
          minimumValue: 0
        }
      },
      shape: {
        options: {},
        type: 'circle'
      },
      size: {
        random: {
          enable: true,
          minimumValue: 1
        },
        value: {
          min: 1,
          max: 3
        },
        animation: {
          count: 0,
          enable: false,
          speed: 4,
          decay: 0,
          sync: false,
          destroy: 'none',
          startValue: 'random',
          minimumValue: 0.3
        }
      },
      stroke: {
        width: 0
      },
      zIndex: {
        random: {
          enable: false,
          minimumValue: 0
        },
        value: 0,
        opacityRate: 1,
        sizeRate: 1,
        velocityRate: 1
      }
    },
    pauseOnBlur: true,
    pauseOnOutsideViewport: true,
    responsive: [],
    style: {},
    themes: [],
    zLayers: 100
  };

  const particlesInit = async (main) => {
    // console.log(main);
    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(main);
  };

  return (
    // TODO: Investigate this
    // @ts-ignore
    <Particles
      id={id}
      init={particlesInit}
      // loaded={particlesLoaded}
      width='100%'
      height={`${size}px`}
      style={{ zIndex: -1, overflow: 'hidden', marginBottom: `-${size}px` }}
      options={particleOptions}
    />
  );
};

export default OceanParticles;
